import axios from 'axios';

const API_URL = 'https://event-li-backend.onrender.com/user';

// Create axios instance with auth header
const authAxios = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to inject token
authAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userjwt');
    if (token) {
      config.headers['x-auth-token'] = token;
      // Or if you prefer Bearer token:
      // config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const getDashboardData = async () => {
  try {
    const response = await authAxios.get('/dashboard');
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message || 'Failed to fetch dashboard data' };
  }
};

export const getRecentEvents = async () => {
  try {
    const response = await authAxios.get('/events/recent');
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message || 'Failed to fetch recent events' };
  }
};

export const getTopReferrers = async () => {
  try {
    const response = await authAxios.get('/top-referrers');
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message || 'Failed to fetch top referrers' };
  }
};